module.exports = __webpack_public_path__ + "img/rainloop.png";